import useSnapshot from "./useSnapshot";

export default function useCollection(query) {
	return useSnapshot(query, true);
}
